import {getFoldersByType, initDatabaseRecord, evolu} from '.';
import {DatabaseItem, FolderType} from '../../types';

export const getDatabases = async (): Promise<DatabaseItem[]> => {
  try {
    if (evolu) {
      await initDatabaseRecord('starpy2', evolu.getOwner().mnemonic);
    }
  } catch (err) {
    console.error(err);
  }

  return (await getFoldersByType(
    FolderType.database,
  )) as DatabaseItem[];
};
